module.exports = __webpack_public_path__ + "img/clearance-homepage-clearance-tablet-compressed.840d99b.png";